import styled from 'styled-components';
import { colors, metrics } from '../../../theme/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Grid, Button as ButtonMUI } from '@mui/material';

export const Content = styled.div`
  text-align: center;
  width: 85%;
`;

export const Icon = styled(AccountCircleIcon)`
  height: ${metrics.sizeIconCredential};
  width: ${metrics.sizeIconCredential};
`;

export const Title = styled.h1`
  font-size: ${metrics.titleCredential};
  margin: 0;
`;

export const Subtitle = styled.h3`
  margin: 0;
  font-weight: ${metrics.weight.regular};
  color: ${colors.mediumBlack};
  align-items: center;
  justify-content: center;
  display: flex;
`;

export const Form = styled(Grid)`
  width: 100%;
  padding-top: 2rem;
`;

export const Button = styled(ButtonMUI)`
  && {
    width: 100%;
    margin-top: 1rem;
  }
`;

export const Links = styled.div`
  width: 100%;
  text-align: right;
  margin: 1rem 0;

  p {
    margin: 0;
    margin-top: 0.5rem;
  }
`;
